import React from "react";
import { contact } from "../../mock";
import useReveal from "../../hooks/useReveal";

export default function Footer() {
  const ref = useReveal();

  return (
    <footer className="footer footer-compact" id="contact" ref={ref}>
      <div className="footer-info" data-reveal>
        <div className="cell">
          <span className="label-mono">Адрес</span>
          <p>{contact.address}</p>
        </div>
        <div className="cell">
          <span className="label-mono">Телефон</span>
          <p>
            <a href={`tel:${contact.phone.replace(/\s/g, "")}`}>{contact.phone}</a>
          </p>
        </div>
        <div className="cell">
          <span className="label-mono">Имейл</span>
          <p>
            <a href={`mailto:${contact.email}`}>{contact.email}</a>
          </p>
        </div>
        <div className="cell">
          <span className="label-mono">Работно време</span>
          <p>{contact.hours}</p>
        </div>
      </div>

      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} Юзлем Идриз · Психолог и психотерапевт</span>
        <span>{contact.city}</span>
        <span>(пространство за разговор)</span>
      </div>
    </footer>
  );
}
